import { SourceEntity } from '../../../source/source-entity';
import { TypeGuard } from '@principle-theorem/shared';
import { isBoolean, isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { STERILISATION_EQUIPMENT_DESTINATION_ENTITY } from '../../../destination/entities/sterilisation-equipment';
import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
} from '@principle-theorem/practice-migrations/interfaces';
import { STERILISATION_EQUIPMENT_RESOURCE_TYPE } from '../../../mappings/sterilisation-equipment';

export const STERILISATION_PACK_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Sterilisation Pack List',
    description: '',
    idPrefix: STERILISATION_EQUIPMENT_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ID4WSterilisationPack {
  id: number;
  contents: string;
  sortOrder: number;
  isActive: boolean;
}

export function isD4WSterilisationPack(
  item: unknown,
  logError: boolean
): item is ID4WSterilisationPack {
  return TypeGuard.interface<ID4WSterilisationPack>(
    {
      id: isNumber,
      contents: isString,
      sortOrder: isNumber,
      isActive: isBoolean,
    },
    logError
  )(item);
}

const STERILISATION_PACK_SOURCE_QUERY = `
SELECT
  ast_pack_contents_list_id AS id,
  pack_contents AS contents,
  sort_order,
  convert_to_boolean(active) as is_active
FROM ast_pack_contents_list
WHERE pack_contents != ''`;

export type D4WSterilisationPack = ISourceEntityTypes<ID4WSterilisationPack>;

export class SterilisationPackSourceEntity extends BaseSourceEntity<D4WSterilisationPack> {
  sourceEntity = STERILISATION_PACK_SOURCE_ENTITY;
  entityResourceType = STERILISATION_EQUIPMENT_RESOURCE_TYPE;
  sourceQuery = STERILISATION_PACK_SOURCE_QUERY;

  verifySourceFn = isD4WSterilisationPack;

  migrationDestinations = [
    STERILISATION_EQUIPMENT_DESTINATION_ENTITY.metadata.key,
  ];

  override translate(_steriliser: ID4WSterilisationPack): unknown {
    return {};
  }

  getSourceRecordId(data: ID4WSterilisationPack): number {
    return data.id;
  }

  getSourceLabel(data: ID4WSterilisationPack): string {
    return data.contents;
  }
}
